import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import indsacmobilecrm from "../Images/indsac-mobile-crm.gif";
export default function InventoryManagementSCM() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="Mobile CRM can be defined as a CRM platform that has been specifically designed for mobile devices and tablets"
      />
      <meta property="og:title" content="Mobile CRM" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/digitalmobile.jsp"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/indsac-mobile-crm.gif"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/indsac-mobile-crm.gif"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="Mobile CRM can be defined as a CRM platform that has been specifically designed for mobile devices and tablets"
      />
      <meta property="og:locale" content="en_US" />
      <title>Mobile CRM | Digital & Mobile :: entelipro.com</title>

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Mobile CRM",
                "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://www.entelipro.com/digitalmobile"`}
        `
      </script>

      <Navbar />
      {/* <!-- breadcrumbs --> */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/services">
                  Services{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/supplychainmanagement">
                  Supply Chain Management (SCM){" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>

              <li className="active">Inventory Management</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsacmobilecrm}
                  alt="product"
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Inventory Management </h4>
                <p className="para">
                  Inventory Management is central to the SCM module, focusing on
                  tracking and managing the stock of raw materials,
                  work-in-progress items, and finished goods. This module
                  provides tools for real-time inventory tracking, demand
                  forecasting, and replenishment planning.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <h5>
                      {" "}
                      <a href="#"></a>
                    </h5>
                    <p className="para">
                      Flexibility is an essential requirement for most
                      professionals today due to the diverse working conditions,
                      including remote working, work from home, and more. 
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <h5>
                      <a href="#"></a>
                    </h5>
                    <p className="para">
                      With the help of mobile CRM, employees can have access to
                      important data irrespective of their location.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Here are some benefits of Inventory Management</h3>
              <div className="row about-about">
                <div className="col-lg-4 col-md-6">
                  <div className="about-grids">
                    <h4>Minimize Stockouts and Overstock</h4>
                    <p className="para">
                      Ensures optimal inventory levels, preventing both
                      shortages and excess stock.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Cost Reduction</h4>

                    <p className="para">
                      Reduces carrying costs by maintaining the right amount of
                      inventory.
                      <br />
                      <br />
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4> Enhanced Cash Flow</h4>
                    <p className="para">
                      {" "}
                      Improves cash flow by avoiding unnecessary stock
                      purchases.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4> Accurate Tracking</h4>
                    <p className="para">
                      {" "}
                      Supports multi-location management, batch tracking, and
                      inventory valuation methods like FIFO, LIFO, and weighted
                      average.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
              </div>
              <br />
              <br />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
